import { render, staticRenderFns } from "./CollegeSearchPopComp.vue?vue&type=template&id=d24b4da8&scoped=true"
import script from "./CollegeSearchPopComp.vue?vue&type=script&lang=js"
export * from "./CollegeSearchPopComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24b4da8",
  null
  
)

export default component.exports